import React from 'react';
import './SkinQuestionHeader.scss';
import { SKIN_ASM_CONSTANTS, SKIN_ASSESSMENT_QUESTION_TEMPLATE } from '../../../../../common/skinAssessmentConstant';

const SkinQuestionHeader = ({ currentSectionId, currentQuestionLabel, isAnonymousType }) => {

  const renderProgress = () => {
    let allProgressParentDiv = [];
    const totalActivityValues = Object.keys(SKIN_ASSESSMENT_QUESTION_TEMPLATE);
    for (let index = 0; index < totalActivityValues.length; index++) {
      const sectionKey = totalActivityValues[index];
      const progressClass =
        SKIN_ASSESSMENT_QUESTION_TEMPLATE[sectionKey]?.progress_tracker <= SKIN_ASSESSMENT_QUESTION_TEMPLATE[currentSectionId]?.progress_tracker ? '' : '_inactive';
      allProgressParentDiv.push(
        <>
          <img
            src={`/images/skin-assessment/skintype-${sectionKey.toLowerCase()}${progressClass}.svg`}
            className="skin-activity-div"
            key={`skin-progress-${sectionKey}`}
          />
        </>
      );
    }
    return allProgressParentDiv;
  };

  return (
    <div className="skin-assessment-header-vector">
      <div className="skin-header-parent">
        <div className="skin-header-progress-base">
          <div className="skin-title word-wrap-break">{SKIN_ASSESSMENT_QUESTION_TEMPLATE[currentSectionId]?.header}{isAnonymousType && (<span className='skin-title-span'>{` ${SKIN_ASM_CONSTANTS.ANONYMOUS_HEADING_TEXT}`}</span>)}</div>
          <div className="skin-progress-parent">{renderProgress()}</div>
        </div>
      </div>
    </div>
  );
}

export default SkinQuestionHeader;
